module.exports = __webpack_public_path__ + "img/save.155d568f.svg";